export default "__VITE_ASSET__CWLHES7U__"